var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLike = function SvgLike(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08329 12.8334H2.33329C2.02387 12.8334 1.72713 12.7105 1.50833 12.4917C1.28954 12.2729 1.16663 11.9762 1.16663 11.6667V7.58341C1.16663 7.274 1.28954 6.97725 1.50833 6.75846C1.72713 6.53966 2.02387 6.41675 2.33329 6.41675H4.08329M8.16663 5.25008V2.91675C8.16663 2.45262 7.98225 2.0075 7.65406 1.67931C7.32587 1.35112 6.88075 1.16675 6.41663 1.16675L4.08329 6.41675V12.8334H10.6633C10.9447 12.8366 11.2177 12.738 11.4321 12.5558C11.6465 12.3735 11.7878 12.1199 11.83 11.8417L12.635 6.59175C12.6603 6.42454 12.6491 6.25381 12.6019 6.09139C12.5548 5.92898 12.4729 5.77875 12.3619 5.65113C12.2509 5.52351 12.1135 5.42154 11.9592 5.35229C11.8049 5.28304 11.6374 5.24817 11.4683 5.25008H8.16663Z",
    stroke: "#C2C6D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/like.67831144.svg";
export { ForwardRef as ReactComponent };